<template>
  <div class="container">
    <el-card class="card">
      <div slot="header" class="header">
        <h2>防水商户报单信息</h2>
      </div>
      <el-row :gutter="20">
        <el-col v-for="(item) in column" :key="item.prop" :span="8" :class="{ 'full-width': item.prop === 'remarks' }">
          <div class="form-group">
            <label class="label">{{ item.label }}:</label>
            <span class="content">{{ formatValue(item, info[item.prop]) }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card v-if="selectedGoods.length > 0" shadow="hover" class="card mt-20">
      <div slot="header" class="clearfix">
        <span class="card-title">商品列表</span>
      </div>
      <div class="card-content">
        <el-table :data="selectedGoods" style="width: 100%" border v-loading="loading">
          <el-table-column prop="goodsName" label="商品名称"></el-table-column>
          <el-table-column prop="num" label="数量"></el-table-column>
        </el-table>
      </div>
    </el-card>
    <div class="actions-footer">
      <el-button type="primary" icon="el-icon-back" @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getGoodList, getMerchantOrder } from "@/api/work/waterProject/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { formatterTime, formatterDate } from "@/util/util";

export default {
  name: 'MerchantView',

  data() {
    return {
      loading: false,
      info: {},
      goodsList: [],
      selectedGoods: [],
      column: [
        // 报单商家名称、电话
        { label: "报单商家名称", prop: "shopName" },
        { label: "报单商家电话", prop: "shopMobile" },
        { label: "销售部门", prop: "region" },
        { label: "施工地址(区/县)", prop: "customAddress" },
        { label: "付款人姓名", prop: "contactName" },
        { label: "付款人电话", prop: "contactMobile" },
        { label: "预约人类型", prop: "appointmentType" },
        { label: "户型", prop: "houseType" },
        { label: "是否使用回填宝", prop: "backFill" },
        { label: "涂料种类", prop: "paintType" },
        { label: "预付款", prop: "advanceCharge" },
        { label: "回填坑位数量", prop: "voucher" },
        { label: "装饰公司/商家名称", prop: "paymentTarget" },
        { label: "质保人电话", prop: "payee" },
        { label: "渠道", prop: "recipientPay" },
        { label: "预计进场时间", prop: "entranceTime", type: "dateTime" },
        { label: "报单日期", prop: "declarationDate", type: "dateTime" },
        { label: "业务员", prop: "introducer" },
        { label: "备注", prop: "remarks" }
      ]
    };
  },

  created() {
    this.initData();
  },

  methods: {
    async initData() {
      const id = this.$route.query.id;
      if (!id) return;

      try {
        this.loading = true;
        const res = await getMerchantOrder(id);
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = this.formatData(data);
          // await this.fetchGoodsList(data.list);
          getGoodList(id).then(res => {
            if (res.code === '200') {
              let selectedGoods = JSON.parse(res.data);
              console.log('edit.vue ~ line: 285 ~ selectedGoods ->', selectedGoods);
              this.selectedGoods = selectedGoods.map(item => ({
                ...item,
                goodsId: item.goodsId,
                num: item.num,
                serviceOrderId: item.serviceOrderId,
                declarationId: item.declarationId,
              }));
            }
          })

        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    formatData(data) {
      if (!data) return {};
      return {
        ...data,
        entranceTime: data.entranceTime ? formatterTime(data.entranceTime) : '',
        declarationDate: data.declarationDate ? formatterDate(data.declarationDate) : ''
      };
    },

    formatValue(item, value) {
      if (!value) return '--';
      return value;
    },

    async fetchGoodsList(selectedGoods) {
      try {
        const res = await findPureWaterGoodsByRootDepartId('waterProof');
        if (res.code === "200") {
          const data = JSON.parse(res.data);
          this.goodsList = data || [];
          this.initSelectedGoods(selectedGoods);
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    },

    initSelectedGoods(selectedGoods) {
      this.selectedGoods = selectedGoods.map(item => ({
        goodsId: item.goodsId,
        num: item.num,
        serviceOrderId: item.serviceOrderId ? item.serviceOrderId.split(',') : item.serviceOrderId,
        declarationId: item.declarationId,
        name: this.getGoodsName(item.goodsId)
      }));
    },

    getGoodsName(goodsId) {
      const goods = this.goodsList.find(g => g.id === goodsId);
      return goods ? goods.name : '--';
    },

    goBack() {
      const item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;

  .card {
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .header {
      background-color: #f5f7fa;
      padding: 15px;

      h2 {
        margin: 0;
        font-size: 18px;
        color: #303133;
      }
    }
  }

  .form-group {
    margin: 15px 0;
    display: flex;
    align-items: flex-start;

    .label {
      width: 120px;
      font-weight: 500;
      color: #606266;
    }

    .content {
      flex: 1;
      color: #303133;
    }
  }

  .mt-20 {
    margin-top: 20px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 500;
  }

  .actions-footer {
    text-align: center;
    padding: 20px 0;
  }

  .full-width {
    width: 100%;
  }
}
</style>
